import styled from 'styled-components';
import { color } from '@magalu/stereo-ui-styles';
import { Link } from '../../../../atoms';
import Box from '../../../../atoms/Box';
export const Container = styled(Box)``;
export const Message = styled(Box).attrs(props => Object.assign({
  color: 'text.white',
  fontWeight: 'bold',
  fontSize: 0
}, props))`
  ${color}
`;
export const StyledLink = styled(Link).attrs(props => Object.assign({
  color: 'text.white',
  fontSize: 0,
  p: 0
}, props))``;